<template lang="pug">
  v-container(fluid)
    v-snackbar(v-model="showSnackBar" :timeout="5000" :color="snackBarColor" ) {{ snackBarText }}
      v-btn.justify-end(fab text @click="showSnackBar = false")
        v-icon fal fa-times-circle
    ControlOrderDialog(
      v-if="showControlDialog && this.currentSelection && this.currentSelection.size > 0"
      :show="showControlDialog"
      :currentSelection="currentSelection"
      :topMenuGroup="menuGroupList[tab]"
      :date="dateLabel"
      :isMultiplePortion="isMultiplePortion"
      :isMultipleGroupMenu="isMultipleGroupMenu"
      :isBoarderNote="isBoarderNote"
      :menuGroupList="menuGroupList"
      :reservationItem="reservationItem"
      @confirm="onConfirmDialogClick"
      @close="onCloseControlDialogClick"
    )

    v-card(flat)
      v-card-title.justify-center.headline.text-center.main-title.selected_date {{ $t('orderPage.headerDateLabel', {date: dateLabel}) }}
      v-row.mb-0(v-if="boarderFoodOrderStore.timeBlocks && boarderFoodOrderStore.timeBlocks.length > 1" align="center" justify="center" )
        v-btn-toggle.text-center(v-model="selectedTimeBlock" show-arrows mandatory  @change="changeTimeBlock")
          v-slide-group( show-arrows prev-icon="far fa-arrow-left" next-icon="far fa-arrow-right" )
            v-slide-item(v-for="(item,idx) in boarderFoodOrderStore.timeBlocks" :key="idx" v-model="selectedTimeBlock" )
              v-btn(active-class="primary") {{item.title}}

    v-card
      v-tabs(centered  v-model="tab" show-arrows
        next-icon="fas fa-arrow-right"
        prev-icon="fas fa-arrow-left"
        v-show="showMenuGroupTabs")
        v-tab( v-for="(i, idx) in menuGroupList" :key="'tab' + i.id") {{i.title}}
      v-tabs-items( v-model="tab"  )
        v-tab-item( v-for="(a, idx) in menuGroupList" :key="'tg' + a.id")
          template(v-if="!isOfferEmpty && !setFreeDay")
            v-list.pa-0.transparent(v-if="a.subGroupList.length")
              GroupOptionSelector(v-if="boarderFoodOrderStore.configuration"
                v-for="(subGroupItem, idx) in a.subGroupList" :key="'sg' + subGroupItem.id" :configuration="boarderFoodOrderStore.configuration" :settingsData="settingsData" :isMultiplePortion="isMultiplePortion" @newAmount="newAmount"
                :menuGroupItem="subGroupItem" :subGroupItem="subGroupItem" :reservationItem="getReservationItem(a.id)" :isManipulationAllowed="isManipulationAllowed" :currentSelection="currentSelection"
                @selectedOptionChange="onSelectedOptionChange(subGroupItem, ...arguments)"
              )

        v-container.text-center.headline.mt-3.reservation-status(:class="statusMessageClass" v-html="reservationStatusMessage")
        v-alert.mx-0.mt-5.pt-5(type="info" border="top" elevation="2" colored-border  :style="{'white-space': 'pre-wrap'}"  v-if="isBoarderNote && reservationItem && reservationItem[0] && reservationItem[0].boarderNote && reservationItem[0].boarderNote !== null " dense  icon="fal fa-info-circle" :v-show="reservationItem[0].boarderNote !== null") {{reservationItem[0].boarderNote}}
        v-alert.mx-0.mt-5(
          v-if="isAlertOrderWaitList" dense type="warning"
          icon="fal fa-exclamation-circle") {{ $t('orderPage.orderWaitList') }}
        v-alert.mx-0.mt-5(dense type="warning" icon="fal fa-exclamation-circle" v-show="isDataChanged") {{ $t('orderPage.dataChangedWarning') }}
        v-card-text.text-center(v-if="isOfferEmpty && !setFreeDay" style="font-size: 16px") {{ $t('orderPage.offerIsEmptyMessage') }}
        GroupControlButtons(
          :date="date" :reservationItem="getFirstReservationItem" :saveInProgress="saveInProgress" :isOfferEmpty="isOfferEmpty" :currentSelection="currentSelection" :isAmountChanged="isAmountChanged"
          :cancellationInProgress="cancellationInProgress" :isSelectionChanged="isDataChanged" :isAcceptanceProcess="isAcceptanceProcess" :isRejected="isRejected" :isAccepted="isAccepted"
          :givingOutFoodInProgress="givingOutFoodInProgress" @giveOutFoodClick="onGiveOutFoodButtonClick" @accepted="acceptOrderClick" @rejected="rejectOrderClick"
          @placeNewReservationClick="onPlaceNewReservationClick" @changeReservationClick="onChangeReservationClick"
          @cancelReservationClick="onCancelReservationClick" @restoreReservationClick="onRestoreReservationClick"
        )

      v-card-title.justify-center(v-if="setFreeDay" ) {{ getEventName }}

    v-dialog(v-model="showCancellationConfirmationDialog" persistent max-width="410")
      v-card
        v-card-title {{ $t('orderPage.cancelReservationConfirmDialogTitle') }}
        v-card-text  {{getTitle}}
        v-card-actions
          v-spacer
          v-btn(text @click="onCancelCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogNoButtonLabel') }}
          v-btn(color="primary" text @click="onConfirmCancellationButtonClick") {{ $t('orderPage.cancelOrderConfirmDialogYesButtonLabel') }}

    v-dialog(v-model="showDeliveryConfirmationDialog" persistent max-width="420")
      v-card
        v-card-title {{ $t('orderPage.confirmDeliveryDialogTitle') }}
        v-card-actions
          v-spacer
          v-btn(text color="primary" @click="onCancelDeliveryButtonClick"
            :disabled="givingOutFoodInProgress") {{ $t('buttons.noButtonLabel') }}
          v-btn(color="primary" @click="onConfirmDeliveryButtonClick"
            :disabled="givingOutFoodInProgress" :loading="givingOutFoodInProgress") {{ $t('buttons.yesButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {DAILY_MENU_TOP_GROUP_CHANGE_SET, DAILY_MENU_TOP_GROUP_SAVED,} from '@/store/getter-types'
import GroupOptionSelector from '@/components/boarder-detail-dialog/GroupOptionSelector.vue'
import {
  ADMIN_DELIVER_FOOD,
  CANCEL_EXISTING_RESERVATION,
  CHANGE_EXISTING_RESERVATION, CHANGE_EXISTING_RESERVATION_STATUS,
  PLACE_NEW_RESERVATION,
  RESTORE_EXISTING_RESERVATION
} from '@/store/action-types'
import GroupControlButtons from '@/components/boarder-detail-dialog/GroupControlButtons.vue'
import {TranslateResult} from 'vue-i18n'
import {
  ChangeExistingReservationPayload,
  CreateNewReservationPayload,
  ReservationsOffersPayload
} from '@/types/payload'
import {
  isSelectionDifferentThenReservation,
  isValidDateForOrdering, validateOrderCorrectness,
} from '@/services/food-orderingGroup'
import moment from 'moment'
import {ReservationStatus} from '@/types/enums'
import {AxiosError} from 'axios'
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";
import {showErrorResponseDialog} from "@/services/error";
import type {AdminDeliverFood, BoarderResponse} from "@/types/service-response";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";
import MenuGroupItemOrder from "@/model/dailymenu/MenuGroupItemOrder";
import {Component, Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";
import BusinessTimeBlockCollection from "@/model/business/BusinessTimeBlockCollection";
import BusinessModel from "@/model/menu/BusinessModel";
import Configuration from "@/model/Configuration";
import ControlOrderDialog from "@/components/boarder-detail-dialog/ControlOrderDialog.vue";
import i18n from "@/i18n";
import _ from "lodash"
import { useBoarderFoodOrderStore } from '@/store/boarderFoodOrderStore'

@Component({
  components: {
    GroupOptionSelector,
    GroupControlButtons,
    ControlOrderDialog
  }
})
export default class TopGroup extends Vue {

  @Action(ADMIN_DELIVER_FOOD) adminDeliverFood!: {(id: number): Promise<AdminDeliverFood> }

  @Prop({type: Object as () => any}) menuGroupItem!: any
  @Prop({type: Date, required: true}) date!: Date
  @Prop({type: Array }) reservationItem!: any[]
  @Prop({type: Object as () => BoarderResponse}) boarder!: BoarderResponse
  @Prop({type: Boolean}) setFreeDay!: boolean
  @Prop({type: String}) getEventName!: string
  @Prop({type: Array as () => any[], required: true}) menuGroupList!: any[]
  @Prop({type: Array as () => BusinessModel[]}) business!: BusinessModel[]
  @Prop({type: Boolean}) isAcceptanceProcess!: boolean
  @Prop({type: Array }) settingsData!: any[]
  @Prop({type: Object, required: true}) readonly customer!: any

  private boarderFoodOrderStore = useBoarderFoodOrderStore()
  private showCancellationConfirmationDialog: boolean = false
  private saveInProgress: boolean = false
  private cancellationInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private currentSelection: Map<MenuGroupItemOrder,any> = new Map()
  private isDataChanged: boolean = false
  private givingOutFoodInProgress: boolean = false
  private showDeliveryConfirmationDialog: boolean = false
  private tab: number | null = null
  private selectedTimeBlock: any | null = null
  private timeBlockId: string | null = null
  private isUpdate: boolean = false
  private showControlDialog: boolean = false
  private isAccepted: boolean = false
  private isRejected: boolean = false
  private isAmountChanged: boolean = false
  private isMultipleGroupMenu: boolean = true

  // <editor-fold desc="Getters">
  get isMultiplePortion (): boolean {
    return this.customer.configuration.allow_multiple_portions
  }

  get isBoarderNote (): boolean {
    return this.customer.configuration.allow_reservation_note || false

  }

  get isAlertOrderWaitList (): boolean {
    return this.isAcceptanceProcess && this.reservationItem && _.first(this.reservationItem) && _.first(this.reservationItem).acceptanceStatus && _.first(this.reservationItem).acceptanceStatus.name === 'waitlisted' && !this.isOfferEmpty
  }

  get getTitle(): any {
    if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.status === 'delivered') {
      return this.$t('orderPage.saveWarningCancelDeliveredOrder')
    } else {
      return this.$t('orderPage.saveWarningCancelOrder')
    }
  }

  get dateLabel(): string {
    return moment(this.date)
        .locale(i18n.locale)
        .format('dddd D.M.Y').toLocaleLowerCase()
  }

  /** Flag či je povolená manipulácia so stavom objednávky alebo nie
   *
   * @return boolean
   */
  get isManipulationAllowed(): boolean {
    if (_.first(this.reservationItem)! && _.first(this.reservationItem)!.status === 'delivered') {
      return false
    } else if (!isValidDateForOrdering(this.date as unknown as Date)) {
      return false
    }

    return true
  }

  get showMenuGroupTabs(): boolean {
    let showMenuGroups = true

    if (this.boarderFoodOrderStore.areTimeBlockLinkedToGroups) {
      showMenuGroups = this.menuGroupList.length > 1
    }

    return showMenuGroups;
  }

  get effectiveBusiness(): BusinessModel {
    return this.customer.businesses[0]
  }

  getReservationItem (menuGroupId: string):  any | null {
    const foundReservationItem: any | undefined = this.reservationItem?.find((item: any) => item.topMenuGroup.id === menuGroupId)
    return foundReservationItem ? foundReservationItem : null
  }

  get getFirstReservationItem (): any | undefined {
    return _.first(this.reservationItem)
  }

  get reservationStatusMessage(): TranslateResult | undefined {
    if (this.isManipulationAllowed) {
      this.$t('orderPage.orderSummaryLabel', { day: this.dateLabel })

      if (_.first(this.reservationItem)!) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.active:
            return this.$t('orderPage.reservationForDateIsActiveMessage', { date: this.dateLabel })
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationForDateIsCanceledMessage', { date: this.dateLabel })
        }
      } else {
        return this.$t('orderPage.noReservationSoFarMessage', { date: this.dateLabel })
      }
    } else {
      if (_.first(this.reservationItem)!) {
        switch (_.first(this.reservationItem)!.status) {
          case ReservationStatus.canceled:
            return this.$t('orderPage.reservationWasCanceledMessage')
          case ReservationStatus.delivered:
            return this.$t('orderPage.reservationWasAlreadyDeliveredMessage')
          case ReservationStatus.notDelivered:
            return this.$t('orderPage.reservationWasNotDeliveredMessage')
          default:
            return this.$t('orderPage.reservationWasProcessedMessage')
        }
      } else if(this.boarderFoodOrderStore.timeBlocks && this.boarderFoodOrderStore.timeBlocks.length == 1){
        const deadLine = moment(this.boarderFoodOrderStore.timeBlocks[0].reservationDeadline.toString(),'HH:mm:ss').format('HH:mm')
        return this.$t('orderPage.noticeOrderFoodBeforeDefinedTime',{deadLine: deadLine})
      }
    }
    return undefined
  }

  get statusMessageClass(): string | undefined {
    if (_.first(this.reservationItem)!) {
      switch (_.first(this.reservationItem)!.status) {
        case ReservationStatus.active:
          return 'reservation-active'
        case ReservationStatus.canceled:
          return 'reservation-canceled'
        case ReservationStatus.delivered:
          return 'reservation-delivered'
        case ReservationStatus.notDelivered:
          return 'reservation-not-delivered'
      }
    }

    return undefined
  }

  get isOfferEmpty(): boolean {
    // Ziadna z podkupin nemoze mat definovanu ponuku
    return this.menuGroupItem.subGroupList.every((i: MenuGroupItemOrder) => {
      return i.optionList.every((option: DailyMenuOptionOrder) => option.offer === undefined)
    })
  }

  get topMenuGroup(): boolean {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_CHANGE_SET]
  }

  get topMenuGroupSaved(): any {
    return this.$store.getters[DAILY_MENU_TOP_GROUP_SAVED]
  }

  //</editor-fold>

  newAmount (option: DailyMenuOptionOrder): void {
    let changes: boolean[] = []
    this.currentSelection.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: MenuGroupItemOrder) => {
      if(value instanceof Array) {
        value.forEach((item: DailyMenuOptionOrder) => {
          if(item && item.offer && item.offer.id === option.offer!.id) {
            item.offer.amount = option.offer!.amount
          }

          if(item.offer) {

            this.reservationItem?.forEach((i: any) => {
              const foundItem = i.reservedOffers.find((a: any) => a.dailyMenuOffer.id === item.offer!.id)
              if (foundItem && foundItem.amount !== item.offer!.amount) {
                changes.push(true)
              } else {
                changes.push(false)
              }
            })

          } else {
            changes.push(false)
          }
        })
      } else {
        if(value && value.offer && value.offer.id === option.offer!.id) {
          value.offer.amount = option.offer!.amount
        }
        if(value.offer) {
          this.reservationItem?.forEach((i: any) => {
            const foundItem = i.reservedOffers.find((item: any) => item.dailyMenuOffer.id === value.offer!.id)
            if (foundItem && foundItem.amount !== value.offer!.amount) {
              changes.push(true)
            } else {
              changes.push(false)
            }
          })
        } else {
          changes.push(false)
        }
      }
    })

    this.isAmountChanged = changes.includes(true)
  }

  // <editor-fold desc="Watchers">
  @Watch('menuGroupItem')
  menuItem(newVal: MenuGroupItemOrder): void {
    if (newVal) {
      this.currentSelection.clear()
      this.setCurrentSelectionByReservation()
      this.updateIsDataChangedFlag()
      this.setTimeBlock()
      this.getTabNumber()

    }
  }

  @Watch('reservationItem')
  reservI(newVal: any): void {
    if(newVal){
      this.updateIsDataChangedFlag()
      this.setTimeBlock()
      this.getTabNumber()
    }
  }

  // </editor-fold>

  getTabNumber() {
    if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.topMenuGroup.title === "Denné menu") {
      this.tab = 0
    }else if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.topMenuGroup.title === "Bagety") {
      this.tab = 1
    }else if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.topMenuGroup.title === "Minútky") {
      this.tab = 2
    }else if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.topMenuGroup.title === "Šaláty") {
      this.tab = 3
    } else if(_.first(this.reservationItem)! && _.first(this.reservationItem)!.topMenuGroup.title === "XXL") {
      this.tab = 4
    } else {
      this.tab = 0
    }
  }

  setTimeBlock (): void {
    if(this.reservationItem) {
      const foundItem: any = this.boarderFoodOrderStore.timeBlocks.find((item: any) => item.id === _.first(this.reservationItem)?.timeBlock.id)
      if(foundItem) {
        const index: number = this.boarderFoodOrderStore.timeBlocks.indexOf(foundItem)
        this.selectedTimeBlock = index
      }
    } else {
      this.selectedTimeBlock = null
      this.boarderFoodOrderStore.timeBlocks.forEach((item: BusinessTimeBlockCollection) => {
          const index: number = this.boarderFoodOrderStore.timeBlocks.indexOf(item)
          this.selectedTimeBlock = index
      })
    }
  }

  changeTimeBlock (item: number): void {
    if(!this.isMultipleGroupMenu) {
      if(_.first(this.reservationItem)! && this.boarderFoodOrderStore.timeBlocks) {
        if(this.boarderFoodOrderStore.timeBlocks[item].id == _.first(this.reservationItem)!.timeBlock.id) {
          this.isDataChanged = false
        } else {
          this.isDataChanged = true
        }
      } else {
        this.isDataChanged = false
      }
    } else {
      if(this.boarderFoodOrderStore.timeBlocks && this.boarderFoodOrderStore.timeBlocks[item] && this.boarderFoodOrderStore.timeBlocks[item].id && this.boarderFoodOrderStore.timeBlocks[item].id && this.reservationItem && this.reservationItem.length > 0) {
        let foundItem: any | null = null
        this.reservationItem.forEach((i: any) => {
          foundItem = i.timeBlock!.id === this.boarderFoodOrderStore.timeBlocks![item]!.id
        })
        if(foundItem) {
          this.isDataChanged = false
        } else{
          this.isDataChanged = true
        }
      } else {
        this.isDataChanged = false
      }
    }

    this.$emit('timeBlockChanged', this.boarderFoodOrderStore.timeBlocks[item]!)
  }

  // <editor-fold desc="Event handlers">
  onSelectedOptionChange(groupItem: MenuGroupItemOrder, selectedOption: DailyMenuOptionOrder | undefined): void {
    if (selectedOption) {
      this.currentSelection.set(groupItem, selectedOption)
    } else if (this.currentSelection.has(groupItem)) {
      this.currentSelection.delete(groupItem)
    }

    this.updateIsDataChangedFlag()
    this.$emit('selectionChange', this.currentSelection)
  }

  onCloseControlDialogClick():void {
    this.showControlDialog = false
  }

  onPlaceNewReservationClick (): void {
    // true lebo nieje dokoncena konfiguracia
    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && !this.isMultipleGroupMenu) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItemOrder = this.menuGroupList[this.tab]
      this.currentSelection.forEach((value: any, key: any) => {
        const foundItem: MenuGroupItemOrder | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItemOrder) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false)) {
        this.isUpdate = false
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        this.currentSelection.forEach((value: any, key: any) => {
          const foundItem: MenuGroupItemOrder | undefined = this.menuGroupList[this.tab!].subGroupList.find((item: MenuGroupItemOrder) => item.id === key.id)
          if(!foundItem) {
            selectionPayload.delete((key))
          }
        })
        //this.onConfirmDialogClick(selectionPayload)
      } else {
        this.showControlDialog = true //this.placeNewReservationClick(this.currentSelection)
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    } else {
      this.showControlDialog = true //this.placeNewReservationClick(this.currentSelection)
    }
  }

  async placeNewReservationClick(selectionPayload: Map<any, DailyMenuOptionOrder | DailyMenuOptionOrder[]>,description: string | null): Promise<void> {
    this.timeBlockId = this.selectedTimeBlock ? `/api/time-block/${this.boarderFoodOrderStore.timeBlocks[this.selectedTimeBlock].id}` : `/api/time-block/${this.boarderFoodOrderStore.timeBlocks[0].id}`
    const business: any = `/api/business/${this.effectiveBusiness.id}`
    if (this.currentSelection && this.tab !== null ) {
      let topMenuGroupId: number = parseFloat(this.menuGroupList[this.tab].id)
      if (topMenuGroupId && validateOrderCorrectness(selectionPayload, this.menuGroupList[this.tab], this.boarderFoodOrderStore.configuration)) {
        this.saveInProgress = true

        if (this.isMultipleGroupMenu) {
          let payloadData: CreateNewReservationPayload[] = []
          selectionPayload.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: any) => {
            const foundTopGroup: any | undefined = this.menuGroupList.find((item: any) => item.subGroupList.find((i: any) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if (value instanceof Array) {
              value.forEach((item: DailyMenuOptionOrder) => {
                reservationsOffers.push({
                  dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`,
                  amount: this.isMultiplePortion ? item.offer!.amount : 1
                })
              })
            } else {
              reservationsOffers.push({
                dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`,
                amount: this.isMultiplePortion ? value.offer!.amount : 1
              })
            }
            const foundPayloadData: any | undefined = payloadData.find((a: any) => a.topMenuGroup == parseInt(foundTopGroup!.id))

            if (!foundPayloadData) {
              payloadData.push(
                  {
                    boarder: this.boarder.id,
                    topMenuGroup: parseFloat(foundTopGroup!.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    date: moment(this.date).format('YYYY-MM-DD'),
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null
                  }
              )
            } else {
              foundPayloadData.reservedOffers = (foundPayloadData.reservedOffers || []).concat(reservationsOffers)
            }
          })

          let promises: any[] = []

          payloadData.forEach((payload: CreateNewReservationPayload) => {
            promises.push(this.createReservation(payload))
          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let topMenuGroupId: number = parseFloat(this.menuGroupList[this.tab].id)
          if (topMenuGroupId && validateOrderCorrectness(selectionPayload, this.menuGroupList[this.tab], this.boarderFoodOrderStore.configuration)) {
            let reservationsOffers: ReservationsOffersPayload[] = []

            selectionPayload.forEach((value) => {
              if (value instanceof Array) {
                value.forEach((item: DailyMenuOptionOrder) => {
                  reservationsOffers.push({
                    dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`,
                    amount: this.isMultiplePortion ? item.offer!.amount : 1
                  })
                })

              } else {
                reservationsOffers.push({
                  dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`,
                  amount: this.isMultiplePortion ? value.offer!.amount : 1
                })
              }
            })
            const payload: CreateNewReservationPayload = {
              boarder: this.boarder.id,
              topMenuGroup: parseFloat(this.menuGroupList[this.tab].id),
              reservedOffers: reservationsOffers,
              timeBlock: this.timeBlockId,
              business: business,
              date: moment(this.date).format('YYYY-MM-DD'),
              boarderNote: description && description.trim().length > 0 ? description.trim() : null
            }

            this.createReservation(payload)

          } else {
            this.snackBarColor = 'error'
            this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
            this.showSnackBar = true
            this.$emit('updateData')
          }
        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
    }
  }

  async createReservation (payload: CreateNewReservationPayload): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(PLACE_NEW_RESERVATION, payload)

      this.$emit('newReservationCreated', reservationItem)
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  acceptOrderClick () {
    this.isAccepted = true
    this.changeReservationStatusClick('accepted')

  }

  rejectOrderClick () {
    this.isRejected = true
    this.changeReservationStatusClick('rejected')
  }

  onChangeReservationClick (): void {
    this.showControlDialog = true
    if(this.currentSelection && this.currentSelection.size > 0 && this.tab !== null && true) {
      let condition: boolean[] = []
      let topMenuGroup: MenuGroupItemOrder = this.menuGroupList[this.tab]
      this.currentSelection.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: any) => {
        const foundItem: MenuGroupItemOrder | undefined = topMenuGroup.subGroupList.find((item: MenuGroupItemOrder) => item.id === key.id)
        condition.push(foundItem ? true : false)
      })

      if(condition.includes(false)) {
        this.isUpdate = true
        this.showControlDialog = true
        let selectionPayload = this.currentSelection
        if(!this.isMultipleGroupMenu){
          this.currentSelection.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: any) => {
            const foundItem: MenuGroupItemOrder | undefined = this.menuGroupList[this.tab!].subGroupList.find((item: MenuGroupItemOrder) => item.id === key.id)
            if(!foundItem) {
              selectionPayload.delete((key))
            }
          })
        }

        //this.onConfirmDialogClick(selectionPayload)

      } else {
        this.isUpdate = true
        this.showControlDialog = true//this.changeReservationClick(this.currentSelection)
      }
    } else if(this.isMultipleGroupMenu) {
      this.isUpdate = true
      this.showControlDialog = true
    }  else {
      this.isUpdate = true
      this.showControlDialog = true //this.changeReservationClick(this.currentSelection)
    }
  }


  onConfirmDialogClick (selectionPayload: Map<MenuGroupItemOrder, DailyMenuOptionOrder | DailyMenuOptionOrder[]>,description: string | null) {

    if(_.first(this.reservationItem)?.topMenuGroup.id){
      this.isUpdate = true
    }
    if(this.isUpdate) {
      this.showControlDialog = false
      this.changeReservationClick(selectionPayload,description)
    } else {
      this.showControlDialog = false
      this.placeNewReservationClick(selectionPayload,description)
    }
  }

  async onChangeReservationStatusClick (payload: any): Promise<void>{
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CHANGE_EXISTING_RESERVATION_STATUS, payload)
      this.$emit('reservationChanged', reservationItem, 'changed')
    } catch(e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.isAccepted = false
      this.isRejected = false
    }
  }

  async changeReservationStatusClick (status: string): Promise<void> {
    let promises: any[] = []
    this.reservationItem.forEach((item: any) => {
      const payload: any = {
        reservationId: item.reservationId,
        acceptanceStatus: status
      }
      promises.push(this.onChangeReservationStatusClick(payload))
    })
    await Promise.all(promises as Promise<Object[]>[])
  }

  async changeReservation (payload: any): Promise<void> {
    try {
      const reservationItem: any[] = await this.$store.dispatch(CHANGE_EXISTING_RESERVATION, payload)
      this.$emit('reservationChanged', reservationItem, 'changed')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
      this.$emit('updateData')
    } finally {
      this.saveInProgress = false
    }
  }

  async changeReservationClick (selectionPayload: Map<any, DailyMenuOptionOrder | DailyMenuOptionOrder[]>,description: string | null): Promise<void> {
    this.timeBlockId = this.selectedTimeBlock ? `/api/time-block/${this.boarderFoodOrderStore.timeBlocks[this.selectedTimeBlock].id}` : `/api/time-block/${this.boarderFoodOrderStore.timeBlocks[0].id}`
    const business: any = `/api/business/${this.effectiveBusiness.id}`
      if (this.tab !== null && validateOrderCorrectness(selectionPayload, this.menuGroupList[this.tab], this.boarderFoodOrderStore.configuration )) {
        this.saveInProgress = true

        if(this.isMultipleGroupMenu) {
          let payloadData: any[] = []
          selectionPayload.forEach((value: DailyMenuOptionOrder | DailyMenuOptionOrder[], key: any) => {
            const foundTopGroup: any = this.menuGroupList.find((item: any) => item.subGroupList.find((i: any) => i.id === key.id))
            let reservationsOffers: ReservationsOffersPayload[] = []
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOptionOrder) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
              })
            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
            }
            const foundPayloadData: any | undefined = payloadData.find((a: any) => a.topMenuGroup === foundTopGroup.id)

            if(!foundPayloadData) {
              payloadData.push(
                  {
                    topMenuGroup: parseFloat(foundTopGroup.id),
                    reservedOffers: reservationsOffers,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarder: this.boarder.id,
                    status: 'active',
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null
                  }
              )
            } else {
              foundPayloadData.reservedOffers = (foundPayloadData.reservedOffers || []).concat(reservationsOffers)
            }
          })

          this.reservationItem!.forEach((item: any) => {
            const foundReservationPayload: any | undefined = payloadData.find((i: any) => item.topMenuGroup.id === i.topMenuGroup)
            if(!foundReservationPayload) {
              payloadData.push(
                  {

                    topMenuGroup: item.topMenuGroup.id,
                    timeBlock: this.timeBlockId!,
                    business: business,
                    boarder: this.boarder.id,
                    status: 'active',
                    boarderNote: description && description.trim().length > 0 ? description.trim() : null
                  }
              )
            }
          })

          let promises: any[] = []

          payloadData.forEach((b: ChangeExistingReservationPayload) => {
            const foundReservation: any | undefined = this.reservationItem!.find((c: any) => c.topMenuGroup.id === b.topMenuGroup)
            if(foundReservation) {
              const payload: any = {
                reservationId: foundReservation.reservationId,
                payload: b
              }
              promises.push(this.changeReservation(payload))
            } else {
              const payload: any = {
                boarder: this.boarder.id,
                topMenuGroup: b.topMenuGroup,
                reservedOffers: b.reservedOffers || [],
                timeBlock: this.timeBlockId!,
                business: business,
                date: moment(this.date).format('YYYY-MM-DD'),
                boarderNote: description && description.trim().length > 0 ? description.trim() : null
              }
              promises.push(this.createReservation(payload))
            }

          })

          await Promise.all(promises as Promise<Object[]>[])

        } else {
          let reservationsOffers: ReservationsOffersPayload[] = []
          selectionPayload.forEach((value) => {
            if(value instanceof Array) {
              value.forEach((item: DailyMenuOptionOrder) => {
                reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${item.offer!.id}`, amount: this.isMultiplePortion ? item.offer!.amount : 1})
                //offerIds.push(parseInt(item.offer!.id))
              })

            } else {
              reservationsOffers.push({dailyMenuOffer: `/api/food-ordering/daily-menu-offer/${value.offer!.id}`, amount: this.isMultiplePortion ? value.offer!.amount : 1})
              //offerIds.push(parseInt(value.offer!.id))
            }
          })

          const payloadData: any = {
            topMenuGroup: parseFloat(this.menuGroupList[this.tab].id),
            reservedOffers: reservationsOffers,
            timeBlock: this.timeBlockId,
            business: business,
            boarderNote: description && description.trim().length > 0 ? description.trim() : null
          }

          const payload: any = {
            reservationId: _.first(this.reservationItem)!.reservationId,
            payload: payloadData
          }
          this.changeReservation(payload)

        }
      } else {
        this.snackBarColor = 'error'
        this.snackBarText = this.$t('orderPage.incompleteOrderMessage')
        this.showSnackBar = true
        this.$emit('updateData')
      }
  }

  onCancelReservationClick(): void {
    this.showCancellationConfirmationDialog = true
  }

  onReservationRstoreClick () {
    this.showControlDialog = true
  }

  async restoreReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, payload)
      this.$emit('reservationChanged', reservationItem, 'canceled')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.cancellationInProgress = false
    }
  }

  async restoredReservation (payload: any): Promise<void> {
    try {
      const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION,payload)
      this.$emit('reservationChanged', reservationItem, 'restored')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.saveInProgress = false
    }
  }

  async onRestoreReservationClick (): Promise<void> {
    if (this.reservationItem && this.isMultipleGroupMenu) {
      this.saveInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoredReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(RESTORE_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        this.$emit('reservationChanged', reservationItem, 'restored')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.saveInProgress = false
      }
    }
  }

  onCancelCancellationButtonClick(): void {
    this.showCancellationConfirmationDialog = false
  }

  async onConfirmCancellationButtonClick (): Promise<void> {
    this.showCancellationConfirmationDialog = false

    if (this.reservationItem &&  this.isMultipleGroupMenu) {
      this.cancellationInProgress = true
      let promises: any[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        promises.push(this.restoreReservation(item))
      })
    } else if(this.reservationItem && !this.isMultipleGroupMenu) {
      try {
        const reservationItem: MenuReservationItem = await this.$store.dispatch(CANCEL_EXISTING_RESERVATION, _.first(this.reservationItem)!)
        this.$emit('reservationChanged', reservationItem, 'canceled')
      } catch (e) {
        this.showSaveErrorMessage(e as AxiosError)
      } finally {
        this.cancellationInProgress = false
      }
    }
  }

  onCancelDeliveryButtonClick(): void {
    this.showDeliveryConfirmationDialog = false
  }

  onGiveOutFoodButtonClick(): void {
    this.showDeliveryConfirmationDialog = true
  }

  async onConfirmDelivery(payload: any): Promise<void> {
    try {
      await this.adminDeliverFood(payload.reservationId)
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
    }
  }

  async onConfirmDeliveryButtonClick(): Promise<void> {
    let promises: any[] = []
    this.reservationItem.forEach((item: any) => {
      const payload: any = {
        reservationId: item.reservationId,

      }
      promises.push(this.onConfirmDelivery(payload))
    })
    try {
      this.givingOutFoodInProgress = true
      await Promise.all(promises as Promise<Object[]>[])
      this.showDeliveryConfirmationDialog = false
      this.$emit('foodDelivered')
    } catch (e) {
      this.showSaveErrorMessage(e as AxiosError)
    } finally {
      this.givingOutFoodInProgress = false
    }
  }

  // </editor-fold>

  /**
   * Zmení flag isDataChanged podľa nastavenia rezervácie
   *
   * Vue nepodporuje reaktivitu pre property typu Map a Set. Preto musí byť zmena flagu riešená explicitne.
   */
  updateIsDataChangedFlag(): void {
    this.isAmountChanged = false
    if (!this.reservationItem) {
      this.isDataChanged = false
    } else {
      this.isDataChanged = isSelectionDifferentThenReservation(this.reservationItem, this.currentSelection,this.isMultipleGroupMenu)
    }
  }

  showSaveErrorMessage(e: AxiosError): void {
    showErrorResponseDialog(this.$t('orderPage.orderNotSaved'), e, this.$t('errorResponseDialog.contactAdministratorMessage').toString())
  }

  setCurrentSelectionByReservation (): void {
    if(this.reservationItem && this.isMultipleGroupMenu){
      let reservedIdList: number[] = []
      this.reservationItem.forEach((item: MenuReservationItem) => {
        item.reservedOfferCollection.forEach((i: any) => {
          reservedIdList.push(i.menuGroupSlot.id)
        })
      })
      this.menuGroupList.forEach((item: any) => {
        item.subGroupList.forEach((i: any) => {
          i.optionList.forEach((a: any,index: any) => {
            if(reservedIdList.includes(parseInt(a.id))) {
              if(this.currentSelection.has(i)) {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.get(i)!.push(a)
              } else {
                this.reservationItem!.forEach((x:any) => {
                  if(a.offer){
                    const foundItem =  x.reservedOffers.find((y:any) => y.dailyMenuOffer.id === a.offer!.id)
                    if(foundItem) {
                      a.offer.amount = foundItem.amount
                    }
                  }
                })

                this.currentSelection.set(i, [a])
              }

            }
          })
        })
      })
    }
  }

  created() {
    this.isMultipleGroupMenu = this.customer.configuration.allow_cross_top_menu_group
    this.setCurrentSelectionByReservation()
  }

  async mounted () {
    if(this.reservationItem){
      this.setTimeBlock()

    }
    if(this.reservationItem && _.first(this.reservationItem)?.topMenuGroup) {
      this.getTabNumber()
    } else {
      this.tab = 0
    }
  }
}
</script>

<style lang="stylus" scoped>
.reservation-active, .reservation-delivered
  background-color #c8e6c9

.reservation-canceled, reservation-not-delivered
  background-color #fadacd

.reservation-status
  >>> em
    font-weight 500
    font-style normal
    text-decoration underline

.main-title
  word-break unset

.selected_date {
  color: #008b8b
}




</style>
